/**
 * Límites de los adjuntos que sube el front (FileUploader y los diálogos que
 * juntan archivos antes de guardar). El server vuelve a validar.
 *
 * Tope por archivo: debajo del límite de 4.5 MB del body en Vercel, con margen
 * para el envoltorio multipart.
 */
export const MAX_UPLOAD_BYTES = 4 * 1024 * 1024;
export const MAX_UPLOAD_MB = 4;

export const ACCEPT_MAP = {
  pdf: { accept: 'application/pdf', label: 'PDF' },
  'pdf-image': {
    accept: 'application/pdf,image/png,image/jpeg',
    label: 'PDF o imagen',
  },
} as const;

/** Motivo por el que el archivo no se puede subir, o null si está bien. */
export function errorDeArchivo(file: File, accept: keyof typeof ACCEPT_MAP = 'pdf-image'): string | null {
  if (file.size > MAX_UPLOAD_BYTES) {
    return `"${file.name}" pesa ${(file.size / (1024 * 1024)).toFixed(1)} MB y el tope es ${MAX_UPLOAD_MB} MB. Comprimilo antes de adjuntarlo.`;
  }
  const permitidos = ACCEPT_MAP[accept].accept.split(',');
  if (!permitidos.some((t) => file.type === t.trim())) {
    return `"${file.name}": tipo de archivo no soportado. Se aceptan: ${ACCEPT_MAP[accept].label}.`;
  }
  return null;
}
